import { useEffect } from 'react';
import { useLocation } from 'react-router';

export function useScrollToAnchor() {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) return;

    const el = document.querySelector(hash);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  }, [hash]);
}
